import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  NotificationBaseWrapper
} from './styled'

export class NotificationBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      spacing,
      spacingTop,
      spacingRight,
      spacingBottom,
      spacingLeft,
      spacingHorizontal,
      spacingVertical,
      bgColor,
      borderWidth,
      borderStyle,
      borderColor,
      borderRadius,
      boxShadow
    } = this.props

    return (
      <NotificationBaseWrapper
        className={ClassNames(
          'notification-base',
          // Option
          className
        )}
        theme={{
          // Default
          padding,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          spacing,
          spacingTop,
          spacingRight,
          spacingBottom,
          spacingLeft,
          spacingHorizontal,
          spacingVertical,
          bgColor,
          borderWidth,
          borderStyle,
          borderColor,
          borderRadius,
          boxShadow
        }}
      >
        {children}
      </NotificationBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingVertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingHorizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingVertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bgColor: PropTypes.string,
    borderWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    boxShadow: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
